<template>
  <div>
    <ul class="leftbox" @mouseenter="enter" @mouseleave="leave" :style="{ width: width, 'background-image': `url(${MenuImg}`, color: `${leftBoxColor}` }" style="transition: width 0.5s;">
      <!-- <div>{{ liArr }}</div> -->
      <div class="title_box" v-if="menuItem && menuItem.meta">{{ menuItem.meta.title }}</div>
      <li v-for="item, index in menuItem.children"  v-show="!item.hidden && menuItem.children"  :key="index" @click="go(item.path)" :style="{ 'backgroundColor': nowPath == item.path ? 'rgba(255, 255, 255, .2)' : '' }">
        <svg-icon :iconClass="item.meta.icon" class="svg-icon" ></svg-icon>
        <span v-if="checkShow1 && item && item.meta">{{ item.meta.title }}</span>
      </li>
      <div class="bottom_box" v-if="checkNum == 1 || checkNum == 2" @click="checkBox">
        <el-tooltip class="item" v-if="checkNum == 1" effect="dark" content="收起菜单栏" placement="top">
          <i class="el-icon-s-fold" :style="{ color: `${leftBoxColor}` }"></i>
        </el-tooltip>
        <i class="el-icon-s-unfold" :style="{ color: `${leftBoxColor}` }" v-if="checkNum == 2"></i>
      </div>
      <div class="bottom_box" v-else @click="regularBox">
        <el-tooltip class="item" effect="dark" content="固定菜单栏" placement="top">
          <i class="el-icon-s-operation" :style="{ color: `${leftBoxColor}` }"></i>
        </el-tooltip>
      </div>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'LeftBox',

  data () {
    return {
      width: '220px',
      checkNum: 1,         /* 状态为1的时候宽为220px 为2的时候宽为64px */
      checkShow1: true     /* 控制所有状态的显示隐藏 */
    };
  },

  mounted () {

  },
  computed: {
    ...mapGetters(['MenuImg', 'leftBoxColor', 'nowPath', 'menuItem'])
  },
  methods: {
    go (url) {
      if (url) {
        this.$store.commit('menu/changeValue', { 'key': 'nowPath', 'value': url })
        this.$router.push(url)
      }
    },
    // 点击切换菜单时
    checkBox () {
      // 状态为1的时候展开状态 宽为220px
      if (this.checkNum == 1) {
        this.width = '64px',   //设置整体盒子 宽为64px
          this.checkShow1 = false  //控制所有该隐藏的隐藏
        this.checkNum = 2      // 设置状态为2
      } else if (this.checkNum == 2) {  //判断状态为2的时候闭合状态 宽为64px
        this.width = '220px'    //设置整体盒子 宽为220px
        this.checkNum = 1      // 设置状态为1
        this.checkShow1 = true  //控制所有显示

      }
    },
    // 鼠标移入事件
    enter () {
      if (this.checkNum == 2) { //判断状态为2的时候闭合状态 宽为64px
        this.width = '220px'  //设置整体盒子 宽为220px
        this.checkNum = 3      // 设置状态为3
        setTimeout(() => {
          this.checkShow1 = true  //控制所有显示
        }, 200)
      }
    },
    // 鼠标移出事件
    leave () {
      if (this.checkNum == 3) {   //此时鼠标移入事件已将状态修改为3
        this.width = '64px'     //设置整体盒子 宽为64px
        this.checkShow1 = false  //控制所有该隐藏的隐藏
        this.checkNum = 2       //设置状态为2
      }
    },
    // 点击固定侧边栏
    regularBox () {
      this.checkShow1 = true   //控制所有显示
      this.checkNum = 1        // 设置状态为1 恢复初始状态
    }
  },
};
</script>

<style lang="scss" scoped>
.svg-icon {
  font-size: 13px;
  margin-right: 16px;
  color: rgba(255, 255, 255, .8) !important
}

.leftbox {
  height: calc(100vh - 60px);
  overflow-y: hidden;
  overflow-x: auto;
  padding-top: 30px !important;
  color: rgba(255, 255, 255, .8);
  position: relative;

  .title_box {
    height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
    padding-left: 22px;
    font-size: 16px;
    font-weight: 700;
  }

  li {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 25px;

    span {
      margin-left: 10px;
      font-size: 14px;
    }
  }

  li:hover {
    background-color: rgba(255, 255, 255, .2) !important;
  }

  .bottom_box {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .bottom_box:hover {
    background-color: rgba(255, 255, 255, .2) !important;
    color: #fff !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/homePage/leftBox/leftBox.vue